

import axios from 'axios';

class GoogleSheetsService {
    async getData(sheetName, range) {
        try {
            const spreadsheetId = '1WBV4WxOFVRNFQoraMvkarAGSIbUSACnYUaW9QNS7aKA';

            // Google Sheets API v4 endpoint để lấy dữ liệu, cần có API key
            const apiUrl = `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}/values/${sheetName}!${range}`;

            // Thay 'YOUR_API_KEY' bằng API key thực tế của bạn
            const apiKey = 'YOUR_API_KEY';

            const response = await axios.get(apiUrl, {
                params: {
                    key: 'AIzaSyBFPvMC0w3qJSsZbmDE8VjiuON_p3-OSFc',
                },
            });

            const values = response.data.values;

            if (!values || values.length === 0) {
                console.log('Không tìm thấy dữ liệu trong sheet được chỉ định.');
                return [];
            }

            // Giả sử hàng đầu tiên chứa headers, trích xuất dữ liệu từ các hàng còn lại
            const headers = values[0];
            const data = values.slice(1).map((row) => {
                const item = {};
                headers.forEach((header, index) => {
                    item[header] = row[index];
                });
                return item;
            });

            return data;
        } catch (error) {
            console.error('Lỗi khi lấy dữ liệu từ Google Sheets:', error);
            throw error;
        }
    }

}

export default new GoogleSheetsService();